// Pure static tab — list of curated tools for franchisees.
// Verbatim port of tab-links from dashboard.html (lines 1819-1880).

const ExternalArrow = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#8a95a5"
    strokeWidth="2"
    className="important-link-arrow"
  >
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

type LinkCardProps = {
  href: string;
  iconBg: string;
  icon: React.ReactNode;
  name: string;
  sub: string;
  callout?: string;
};

function LinkCard({ href, iconBg, icon, name, sub, callout }: LinkCardProps) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="important-link-card">
      <div className="important-link-icon" style={{ background: iconBg }}>
        {icon}
      </div>
      <div className="important-link-text">
        <div className="important-link-name">{name}</div>
        <div className="important-link-sub">{sub}</div>
        {callout && <div className="important-link-callout">{callout}</div>}
      </div>
      <ExternalArrow />
    </a>
  );
}

export default function ImportantLinksTab() {
  return (
    <div className="important-links">
      <h3 className="important-links-title">Important Links</h3>
      <div className="important-links-grid">
        <LinkCard
          href="https://www.canva.com/login"
          iconBg="linear-gradient(135deg,#00c4cc 0%,#7d2ae8 100%)"
          icon={
            <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 5a7 7 0 1 0 7 7" stroke="#00c4cc" strokeWidth="2" fill="none" />
            </svg>
          }
          name="Canva"
          sub="Access thousands of pre-created marketing materials and Amada's digitized brand book."
        />

        <LinkCard
          href="https://dashboard.chatpath.com"
          iconBg="#4338ca"
          icon={
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
            </svg>
          }
          name="Digital AirStrike Dashboard"
          sub="Chatbot login · dashboard.chatpath.com"
        />

        <LinkCard
          href="https://theamadastore.com"
          iconBg="#0e7490"
          icon={
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <polyline points="6 9 6 2 18 2 18 9" />
              <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
              <rect x="6" y="14" width="12" height="8" />
            </svg>
          }
          name="Amada Print Store"
          sub="Print materials · theamadastore.com"
          callout="➜ Order Marketing-In-A-Box here!"
        />

        <LinkCard
          href="https://amada.americommerce.com"
          iconBg="#b91c1c"
          icon={
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z" />
            </svg>
          }
          name="Amada Clothing Store"
          sub="Branded apparel · amada.americommerce.com"
        />

        <LinkCard
          href="https://crm.welcomehomesoftware.com/users/sign_in"
          iconBg="#0d9488"
          icon={
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          }
          name="WelcomeHome CRM"
          sub="Click here to log in to your CRM"
        />

        <LinkCard
          href="https://forms.zohopublic.com/jeremiahbrooker/form/AFIMasterTicketingSystem/formperma/6YHtZPSonFRyvbb7gpRtNl3ITHooraR0tED4VGTpQvs"
          iconBg="linear-gradient(135deg,#16a34a 0%,#0d9488 100%)"
          icon={
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z" />
              <path d="M13 5v2" />
              <path d="M13 11v2" />
              <path d="M13 17v2" />
            </svg>
          }
          name="Submit a Ticket"
          sub="Marketing ticketing system — report a dashboard bug, request a feature, or ask for design work. Submitted through Zoho."
        />
      </div>
    </div>
  );
}
